import { render, staticRenderFns } from "./LocalVerification.vue?vue&type=template&id=4ca1a642"
import script from "./LocalVerification.vue?vue&type=script&lang=js"
export * from "./LocalVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports